// Package imports:
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
// Component imports:
import GEMMAQContactForm from '../ContactForms/GEMMAQContactForm/GEMMAQContactForm';

const GEMMAQLicense: React.FC = () => {
    return (
        <div className='main KCL_GEMMAQ-license'>
            <div className='section section--contact'>
                <div className="shell">
                    <div className='section__inner'>
                        <div className='section__head'>
                            <h1>GEMMAQ notkunarleyfi</h1>
                            <p className='larger'>GEMMAQ notkunarleyfið er 12 mánaða samningur milli fyrirtækis og Keldunnar.</p>
                            <p className='list-heading'>Í leyfinu felst meðal annars:</p>

                            <ul className="list-option-checks">
                                <li>
                                    <FontAwesomeIcon icon={faCheck} className="icon-fa" />
                                    Heimild til birtingar á kvarðanum á vefsíðu fyrirtækis, sem uppfærist sjálfkrafa ef kynjahlutföll breytast í stjórn eða framkvæmdastjórn þess og/eða GEMMAQ
                                    einkunn þess hækkar eða lækkar.
                                </li>
                                <li>
                                    <FontAwesomeIcon icon={faCheck} className="icon-fa" />
                                    Heimild til notkunar á kvarðanum í kynningarefni og hvers kyns markaðsefni.
                                </li>
                                <li>
                                    <FontAwesomeIcon icon={faCheck} className="icon-fa" />
                                    Heimild til notkunar á kvarðanum í greiningarvinnu og greiningarefni innan fyrirtækis og/eða til birtingar, sem sagt í samfélagsskýrslum eða ársskýrslu fyrirtækis.
                                </li>
                            </ul>

                            <p className='price'>Verð: 180.000 kr. á ári.</p>
                        </div>

                        <div className="section__body">
                            <div className='section__content form form--signup'>
                                <GEMMAQContactForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GEMMAQLicense;